'use client'

import {
  createContext,
  useContext,
  useState,
  ReactNode,
  Dispatch,
  SetStateAction,
} from 'react'

interface AppContextType {
  user: Record<string, any>
  setUser: Dispatch<SetStateAction<Record<string, any>>>
}

// Create Context
export const AppContext = createContext<AppContextType | undefined>(undefined)

// Provider Component
export const AppContextProvider = ({children}: {children: ReactNode}) => {
  const [user, setUser] = useState(localStorage.getItem('user') || {})

  return (
    <AppContext.Provider
      value={{
        user,
        setUser,
      }}>
      {children}
    </AppContext.Provider>
  )
}

// Custom Hook
export const usePopup = () => {
  const context = useContext(AppContext)
  if (!context) {
    throw new Error('usePopup must be used within a AppContextProvider')
  }
  return context
}
